export const FETCH_HOME_DATA = 'FETCH_HOME_DATA';

export const SET_HOME_DATA = 'SET_HOME_DATA';

export const SET_HOME_CALL_ERROR = 'SET_HOME_CALL_ERROR';

export const SET_VUID = 'SET_VUID';

export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export const SHOW_HELP = 'SHOW_HELP';

export const SUBMIT_CONTACT = 'SUBMIT_CONTACT';

export const UPDATE_CONTACT_STS = 'UPDATE_CONTACT_STS';

export const SET_AUTHTAB = 'SET_AUTHTAB';

export const SET_OPEN_PRIVACY_MODAL = 'SET_OPEN_PRIVACY_MODAL';

export const FETCH_PUBLIC_LIBRARIES = 'FETCH_PUBLIC_LIBRARIES';

export const FETCH_PUBLIC_LIBRARIES_SUCCESS = 'FETCH_PUBLIC_LIBRARIES_SUCCESS';

export const FETCH_PUBLIC_LIBRARIES_ERROR = 'FETCH_PUBLIC_LIBRARIES_ERROR';

export const FETCH_DSP_URL_SUCCESS = 'FETCH_DSP_URL_SUCCESS';

export const FETCH_DSP_URL_ERROR = 'FETCH_DSP_URL_ERROR';

export const FETCH_DSP_URL = 'FETCH_DSP_URL';
